import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


export default class StickyProvider extends PureComponent {

  static childContextTypes = {
    sticky: PropTypes.shape({
      subscribe: PropTypes.func,
      unsubscribe: PropTypes.func,
    }),
  }

  getChildContext() {
    return {
      sticky: {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
      },
    }
  }

  // events = [
  //   'resize',
  //   'scroll',
  //   'touchstart',
  //   'touchmove',
  //   'touchend',
  // ]

  node = null
  subscribers = []

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  subscribe = (handler) => {
    this.subscribers.push(handler)
  }

  unsubscribe = (handler) => {
    this.subscribers = this.subscribers.filter((current) => current !== handler)
  }

  handleScroll = () => {
    this.subscribers.forEach((handler) => handler())
  }

  render() {

    return (
      <div
        {...this.props}
        style={{ height: '100%' }}
        ref={(node) => this.node = node}
      />
    )
  }
}
